"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentSpectatorStatus = void 0;
var TournamentSpectatorStatus;
(function (TournamentSpectatorStatus) {
    /**
     * Spectator invited to the tournament by tournament creator
     */
    TournamentSpectatorStatus["Invited"] = "invited";
    /**
     * Spectator accepted the invitation
     */
    TournamentSpectatorStatus["Standby"] = "standby";
    /**
     * Spectator declined the invitation
     */
    TournamentSpectatorStatus["Declined"] = "declined";
})(TournamentSpectatorStatus = exports.TournamentSpectatorStatus || (exports.TournamentSpectatorStatus = {}));
//# sourceMappingURL=tournament-spectator-status.js.map